export default __webpack_public_path__ + "1d863feaf604baab61a9e786e334868a.png";